/* Lapa theme scripts */
(function () {
  'use strict';

  const theme = window.LapaTheme || { routes: {}, strings: {} };
  if (window.Shopify && window.Shopify.designMode) {
    document.documentElement.classList.add('shopify-design-mode');
  }

  /* ---------------- Money ---------------- */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    cents = Number(cents) || 0;
    const fmt = format || theme.moneyFormat || '{{amount}} kr';
    const placeholder = /\{\{\s*(\w+)\s*\}\}/;
    const dec = cents % 100 === 0 ? 0 : 2;
    function withDelimiters(number, precision, thousands, decimal) {
      thousands = thousands === undefined ? ',' : thousands;
      decimal = decimal === undefined ? '.' : decimal;
      const fixed = (number / 100).toFixed(precision);
      const parts = fixed.split('.');
      const whole = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + thousands);
      return parts[1] ? whole + decimal + parts[1] : whole;
    }
    const match = fmt.match(placeholder);
    if (!match) return (cents / 100).toFixed(dec);
    let value;
    switch (match[1]) {
      case 'amount': value = withDelimiters(cents, dec); break;
      case 'amount_no_decimals': value = withDelimiters(cents, 0); break;
      case 'amount_with_comma_separator': value = withDelimiters(cents, dec, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = withDelimiters(cents, 0, '.', ','); break;
      case 'amount_with_space_separator': value = withDelimiters(cents, dec, ' ', ','); break;
      case 'amount_no_decimals_with_space_separator': value = withDelimiters(cents, 0, ' ', ','); break;
      case 'amount_with_apostrophe_separator': value = withDelimiters(cents, dec, "'", '.'); break;
      default: value = withDelimiters(cents, dec);
    }
    return fmt.replace(placeholder, value).replace(/<[^>]*>/g, '');
  }
  window.LapaFormatMoney = formatMoney;

  /* ---------------- Body lock ---------------- */
  function lock(on) { document.body.classList.toggle('is-locked', on); }

  /* ---------------- Header ---------------- */
  function initHeader() {
    const wrapper = document.querySelector('[data-header-wrapper]');
    if (wrapper) {
      const onScroll = () => wrapper.classList.toggle('is-scrolled', window.scrollY > 8);
      onScroll();
      window.addEventListener('scroll', onScroll, { passive: true });
    }
    const menu = document.querySelector('[data-mobile-menu]');
    if (!menu) return;
    const open = () => { menu.classList.add('is-open'); menu.setAttribute('aria-hidden', 'false'); lock(true); };
    const close = () => { menu.classList.remove('is-open'); menu.setAttribute('aria-hidden', 'true'); lock(false); };
    document.querySelectorAll('[data-menu-open]').forEach((b) => b.addEventListener('click', open));
    menu.querySelectorAll('[data-menu-close]').forEach((b) => b.addEventListener('click', close));
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') close(); });
  }

  /* ---------------- Cart drawer ---------------- */
  const CartDrawer = {
    el: null,
    init() {
      this.el = document.querySelector('[data-cart-drawer]');
      if (!this.el) return;
      if (!this.el.dataset.bound) { this.bind(); this.el.dataset.bound = 'true'; }
      document.querySelectorAll('[data-cart-open]').forEach((a) => {
        if (a.dataset.bound) return;
        a.dataset.bound = 'true';
        a.addEventListener('click', (e) => { e.preventDefault(); this.open(); });
      });
    },
    bind() {
      this.el.addEventListener('click', (e) => {
        if (e.target.closest('[data-drawer-close]')) {
          const link = e.target.closest('a[data-drawer-close]');
          if (!link) e.preventDefault();
          this.close();
          return;
        }
        const btn = e.target.closest('[data-qty-change]');
        if (btn) {
          const line = btn.closest('[data-line]');
          const input = line.querySelector('input');
          const next = Math.max(0, parseInt(input.value, 10) + parseInt(btn.dataset.qtyChange, 10));
          this.change(line.dataset.key, next);
          return;
        }
        const quick = e.target.closest('[data-quick-add]');
        if (quick) {
          quick.disabled = true;
          if (this.el) this.el.classList.add('is-loading');
          addItems([{ id: Number(quick.dataset.quickAdd), quantity: 1 }])
            .then(() => this.refresh())
            .catch(() => { quick.disabled = false; })
            .finally(() => { if (this.el) this.el.classList.remove('is-loading'); });
          return;
        }
        const rm = e.target.closest('[data-remove]');
        if (rm) {
          e.preventDefault();
          this.change(rm.closest('[data-line]').dataset.key, 0);
        }
      });
      this.el.addEventListener('change', (e) => {
        if (e.target.matches('[data-line] input')) {
          const line = e.target.closest('[data-line]');
          this.change(line.dataset.key, Math.max(0, parseInt(e.target.value, 10) || 0));
        }
      });
      document.addEventListener('keydown', (e) => { if (e.key === 'Escape') this.close(); });
    },
    open() {
      if (!this.el) { window.location.href = theme.routes.cart; return; }
      this.el.classList.add('is-open');
      this.el.setAttribute('aria-hidden', 'false');
      lock(true);
      const focusable = this.el.querySelector('button[data-drawer-close]');
      if (focusable) focusable.focus();
    },
    close() {
      if (!this.el || !this.el.classList.contains('is-open')) return;
      this.el.classList.remove('is-open');
      this.el.setAttribute('aria-hidden', 'true');
      lock(false);
    },
    async refresh() {
      const root = (theme.routes.root || '/').replace(/\/$/, '');
      const res = await fetch(`${root}/?sections=cart-drawer,cart-count`);
      const data = await res.json();
      if (data['cart-drawer'] && this.el) {
        const doc = new DOMParser().parseFromString(data['cart-drawer'], 'text/html');
        const fresh = doc.querySelector('[data-cart-drawer-inner]');
        const current = this.el.querySelector('[data-cart-drawer-inner]');
        if (fresh && current) current.replaceWith(fresh);
      }
      if (data['cart-count']) {
        const doc = new DOMParser().parseFromString(data['cart-count'], 'text/html');
        const count = doc.querySelector('[data-count]');
        if (count) {
          document.querySelectorAll('[data-cart-count]').forEach((el) => {
            el.textContent = count.dataset.count === '0' ? '' : count.dataset.count;
            el.dataset.count = count.dataset.count;
          });
        }
      }
    },
    async change(key, quantity) {
      if (this.el) this.el.classList.add('is-loading');
      try {
        await fetch(`${theme.routes.cartChange}.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: key, quantity })
        });
        await this.refresh();
      } finally {
        if (this.el) this.el.classList.remove('is-loading');
      }
    }
  };
  window.LapaCart = CartDrawer;

  async function addItems(items) {
    const res = await fetch(`${theme.routes.cartAdd}.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items })
    });
    const data = await res.json();
    if (!res.ok || data.status) {
      throw new Error(data.description || data.message || theme.strings.error);
    }
    return data;
  }

  /* ---------------- Buy box ---------------- */
  class LapaBuyBox extends HTMLElement {
    connectedCallback() {
      const json = this.querySelector('[data-product-json]');
      if (!json) return;
      this.product = JSON.parse(json.textContent);
      this.colorIndex = parseInt(this.dataset.colorIndex, 10);
      this.form = this.querySelector('[data-product-form]');
      this.variantInput = this.querySelector('[data-variant-input]');
      this.qtyInput = this.querySelector('[data-qty-input]');
      this.addButton = this.querySelector('[data-add-button]');
      this.addLabel = this.querySelector('[data-add-label]');
      this.errorEl = this.querySelector('[data-error]');
      this.slotsWrap = this.querySelector('[data-slots]');
      this.slotsList = this.querySelector('[data-slots-list]');
      this.tiers = Array.from(this.querySelectorAll('[data-tier]'));

      const current = this.product.variants.find((v) => String(v.id) === String(this.variantInput.value)) || this.product.variants[0];
      this.selected = current.options.slice();
      this.slotColors = [];
      this.slotsTouched = false;

      this.querySelectorAll('.swatch[data-option-index]').forEach((sw) => {
        sw.addEventListener('click', () => this.selectOption(parseInt(sw.dataset.optionIndex, 10), sw.dataset.value));
      });
      this.querySelectorAll('[data-option-select]').forEach((sel) => {
        sel.addEventListener('change', () => this.selectOption(parseInt(sel.dataset.optionIndex, 10), sel.value));
      });
      this.tiers.forEach((t) => t.addEventListener('change', () => this.onTierChange()));
      this.form.addEventListener('submit', (e) => this.onSubmit(e));

      this.onTierChange();
      this.updateAvailability();
    }

    get colorValues() {
      if (this.colorIndex < 0) return [];
      const vals = [];
      this.product.variants.forEach((v) => {
        const val = v.options[this.colorIndex];
        if (!vals.includes(val)) vals.push(val);
      });
      return vals;
    }

    get quantity() {
      const checked = this.tiers.find((t) => t.checked);
      return checked ? parseInt(checked.dataset.qty, 10) : 1;
    }

    findVariant(options) {
      return this.product.variants.find((v) => v.options.every((o, i) => o === options[i]));
    }

    get currentVariant() { return this.findVariant(this.selected); }

    selectOption(index, value) {
      this.selected[index] = value;
      if (index === this.colorIndex) {
        this.querySelectorAll(`.swatch[data-option-index="${index}"]`).forEach((sw) => {
          const active = sw.dataset.value === value;
          sw.classList.toggle('is-active', active);
          sw.setAttribute('aria-checked', active ? 'true' : 'false');
        });
        const label = this.querySelector('[data-color-label]');
        if (label) label.textContent = value;
        if (!this.slotsTouched) this.slotColors = this.slotColors.map(() => value);
        this.renderSlots();
      }
      const variant = this.currentVariant;
      if (variant) {
        this.variantInput.value = variant.id;
        this.updateUrl(variant);
        this.dispatchEvent(new CustomEvent('lapa:variant-change', { bubbles: true, detail: { variant } }));
      }
      this.updatePrices();
      this.updateAvailability();
    }

    updateUrl(variant) {
      if (!this.closest('[data-main-product]')) return;
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    }

    onTierChange() {
      this.tiers.forEach((t) => t.closest('.tier').classList.toggle('is-active', t.checked));
      const qty = this.quantity;
      const color = this.colorIndex > -1 ? this.selected[this.colorIndex] : null;
      while (this.slotColors.length < qty) this.slotColors.push(color);
      this.slotColors.length = qty;
      this.qtyInput.value = qty;
      this.renderSlots();
      this.updatePrices();
    }

    renderSlots() {
      if (!this.slotsWrap || this.colorIndex < 0) return;
      const qty = this.quantity;
      const values = this.colorValues;
      if (qty < 2 || values.length < 2) { this.slotsWrap.hidden = true; return; }
      this.slotsWrap.hidden = false;
      const swatchColors = {};
      this.querySelectorAll(`.swatch[data-option-index="${this.colorIndex}"]`).forEach((sw) => {
        swatchColors[sw.dataset.value] = sw.style.getPropertyValue('--swatch');
      });
      this.slotsList.innerHTML = '';
      this.slotColors.forEach((val, i) => {
        const row = document.createElement('div');
        row.className = 'slot';
        const name = document.createElement('span');
        name.className = 'slot__name';
        name.textContent = `Flaska ${i + 1}`;
        row.appendChild(name);
        const group = document.createElement('div');
        group.className = 'swatches';
        group.setAttribute('role', 'radiogroup');
        values.forEach((v) => {
          const b = document.createElement('button');
          b.type = 'button';
          b.className = 'swatch' + (v === val ? ' is-active' : '');
          b.style.setProperty('--swatch', swatchColors[v] || '#ccc');
          b.setAttribute('role', 'radio');
          b.setAttribute('aria-checked', v === val ? 'true' : 'false');
          b.setAttribute('aria-label', `${v}, flaska ${i + 1}`);
          b.title = v;
          b.addEventListener('click', () => {
            this.slotsTouched = true;
            this.slotColors[i] = v;
            this.renderSlots();
          });
          group.appendChild(b);
        });
        row.appendChild(group);
        const label = document.createElement('span');
        label.className = 'muted';
        label.textContent = val;
        row.appendChild(label);
        this.slotsList.appendChild(row);
      });
    }

    updatePrices() {
      const variant = this.currentVariant;
      if (!variant) return;
      this.tiers.forEach((t) => {
        const qty = parseInt(t.dataset.qty, 10);
        const pct = parseFloat(t.dataset.discount) || 0;
        const override = parseInt(t.dataset.override, 10) || 0;
        const base = variant.price * qty;
        const final = override > 0 ? override : Math.round(base * (100 - pct) / 10000) * 100;
        const card = t.closest('.tier');
        const p = card.querySelector('[data-tier-price]');
        const c = card.querySelector('[data-tier-compare]');
        const s = card.querySelector('[data-tier-save]');
        if (p) p.textContent = formatMoney(final);
        if (c) c.textContent = formatMoney(base);
        if (s) s.textContent = `Spara ${formatMoney(base - final)}`;
      });
      const priceEl = document.querySelector(`[data-price-for="${this.dataset.section}"]`);
      if (priceEl) {
        const cur = priceEl.querySelector('.price__current');
        if (cur) cur.textContent = formatMoney(variant.price);
        const cmp = priceEl.querySelector('.price__compare');
        if (cmp) cmp.textContent = variant.compare_at_price > variant.price ? formatMoney(variant.compare_at_price) : '';
      }
    }

    updateAvailability() {
      const variant = this.currentVariant;
      const available = variant && variant.available;
      this.addButton.disabled = !available;
      this.addLabel.textContent = available ? theme.strings.addToCart : (variant ? theme.strings.soldOut : 'Ej tillgänglig');
      if (this.colorIndex > -1) {
        this.querySelectorAll(`.swatch[data-option-index="${this.colorIndex}"]`).forEach((sw) => {
          const opts = this.selected.slice();
          opts[this.colorIndex] = sw.dataset.value;
          const v = this.findVariant(opts);
          sw.classList.toggle('is-unavailable', !v || !v.available);
        });
      }
    }

    buildItems() {
      const addons = Array.from(this.querySelectorAll('[data-addon]:checked')).map((el) => ({ id: Number(el.value), quantity: 1 }));
      return this.buildMainItems().concat(addons);
    }

    buildMainItems() {
      const qty = this.quantity;
      const base = this.currentVariant;
      if (this.colorIndex < 0 || qty < 2 || this.colorValues.length < 2) {
        return [{ id: base.id, quantity: qty }];
      }
      const counts = {};
      const order = [];
      this.slotColors.forEach((color) => {
        const opts = this.selected.slice();
        opts[this.colorIndex] = color;
        const v = this.findVariant(opts) || base;
        if (!counts[v.id]) order.push(v.id);
        counts[v.id] = (counts[v.id] || 0) + 1;
      });
      return order.map((id) => ({ id: Number(id), quantity: counts[id] }));
    }

    async onSubmit(e) {
      e.preventDefault();
      if (!this.currentVariant) return;
      this.errorEl.hidden = true;
      this.addButton.classList.add('is-loading');
      this.addButton.setAttribute('aria-busy', 'true');
      try {
        await addItems(this.buildItems());
        if (theme.cartType === 'drawer' && CartDrawer.el) {
          await CartDrawer.refresh();
          CartDrawer.open();
        } else {
          window.location.href = theme.routes.cart;
        }
      } catch (err) {
        this.errorEl.textContent = err.message || theme.strings.error;
        this.errorEl.hidden = false;
      } finally {
        this.addButton.classList.remove('is-loading');
        this.addButton.removeAttribute('aria-busy');
      }
    }
  }
  if (!customElements.get('lapa-buy-box')) customElements.define('lapa-buy-box', LapaBuyBox);

  /* ---------------- Product gallery ---------------- */
  function initGalleries() {
    document.querySelectorAll('[data-gallery]').forEach((gallery) => {
      if (gallery.dataset.bound) return;
      gallery.dataset.bound = 'true';
      const main = gallery.querySelector('[data-gallery-main]');
      const thumbs = Array.from(gallery.querySelectorAll('[data-thumb]'));
      const show = (thumb) => {
        if (!thumb || !main) return;
        thumbs.forEach((t) => t.classList.toggle('is-active', t === thumb));
        const img = main.querySelector('img');
        if (img) {
          img.removeAttribute('sizes');
          img.srcset = thumb.dataset.srcset || '';
          img.src = thumb.dataset.src;
          img.alt = thumb.dataset.alt || '';
          img.setAttribute('sizes', '(min-width: 990px) 55vw, 100vw');
        }
      };
      thumbs.forEach((t) => t.addEventListener('click', () => show(t)));
      const section = gallery.closest('[data-main-product]');
      if (section) {
        section.addEventListener('lapa:variant-change', (e) => {
          const id = e.detail.variant.media_id;
          if (!id) return;
          const thumb = thumbs.find((t) => t.dataset.mediaId === String(id));
          if (thumb) show(thumb);
        });
      }
    });
  }

  /* ---------------- Sticky product bar ---------------- */
  function initSticky() {
    const bar = document.querySelector('[data-sticky-bar]');
    const target = document.querySelector('[data-main-product] [data-add-button]');
    if (!bar || !target || !('IntersectionObserver' in window)) return;
    const io = new IntersectionObserver(([entry]) => {
      const past = !entry.isIntersecting && entry.boundingClientRect.top < 0;
      bar.classList.toggle('is-visible', past);
    });
    io.observe(target);
    bar.querySelector('button').addEventListener('click', () => {
      const tiers = document.querySelector('[data-main-product] .tiers') || target;
      tiers.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
  }

  /* ---------------- Cart page quantity ---------------- */
  function initCartPage() {
    const form = document.querySelector('[data-cart-page]');
    if (!form) return;
    form.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-qty-change]');
      if (!btn) return;
      const input = btn.closest('.qty').querySelector('input');
      input.value = Math.max(0, parseInt(input.value, 10) + parseInt(btn.dataset.qtyChange, 10));
      form.submit();
    });
    form.addEventListener('change', (e) => {
      if (e.target.matches('.qty input')) form.submit();
    });
  }

  /* ---------------- Reveal on scroll ---------------- */
  function initReveal() {
    const els = document.querySelectorAll('.reveal:not(.is-visible)');
    if (!('IntersectionObserver' in window)) { els.forEach((el) => el.classList.add('is-visible')); return; }
    const io = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) { entry.target.classList.add('is-visible'); io.unobserve(entry.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    els.forEach((el) => io.observe(el));
  }

  function init() {
    initHeader();
    CartDrawer.init();
    initGalleries();
    initSticky();
    initCartPage();
    initReveal();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  document.addEventListener('shopify:section:load', () => { initGalleries(); initReveal(); CartDrawer.init(); });
})();
